import { createSelector } from '@reduxjs/toolkit';
import { Shape } from '../types';
import { getShapes } from './getShapes';

export const getSelectedShapes = createSelector(getShapes, (shapes): Shape[] => shapes.filter((s) => s.selected));
